import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import DialogWrapper from "components/DialogWrapper";

const IncomeTaxEChallanInfo = (props) => {
    const { open, setOpen } = props;
    return (
        <DialogWrapper
            title="Important Information on Income Tax e-Challan"
            open={open}
            setOpen={setOpen}
            width="lg"
        >
            <Box sx={{ padding: 2, backgroundColor: '#f9f9f9', borderRadius: 2 }}>
                <Typography variant="h6" component="h2" gutterBottom>
                    Important Information:
                </Typography>
                <Typography variant="body1" gutterBottom>
                This section only contains Challans generated and remitted through the e-filing Portal. It does not provide details of Challans paid through the NSDL / Protean website.
                </Typography>
            </Box>
        </DialogWrapper>
    )
}

export default IncomeTaxEChallanInfo